<script setup lang="ts">
import "@/assets/styles/legal.css";
import SidebarComponent from "@/components/SidebarComponent.vue";
import FooterImpressum from "@/components/FooterImpressum.vue";
</script>

<template>

  <section class="legal-page">

    <div class="legal-container">

      <span class="legal-badge">
        Datenschutz
      </span>

      <h1>
        Datenschutzerklärung
      </h1>

      <!-- Allgemein -->
      <div class="legal-card">

        <h2>1. Allgemeine Hinweise</h2>

        <p>
          Der Schutz Ihrer persönlichen Daten ist uns wichtig.
          Nachfolgend informieren wir Sie darüber,
          welche Daten auf dieser Website erfasst
          und wie diese verwendet werden.
        </p>

      </div>

      <!-- Verantwortlicher -->
      <div class="legal-card">

        <h2>2. Verantwortlicher</h2>

        <p>
          TestGarten<br>
          Garten- & Landschaftsbau<br>
          Max Mustermann<br><br>

          Musterstraße 12<br>
          65183 Wiesbaden<br><br>

          E-Mail: info@testgarten.de<br>
          Telefon: +49 123 456789
        </p>

      </div>

      <!-- Hosting -->
      <div class="legal-card">

        <h2>3. Hosting</h2>

        <p>
          Beim Besuch dieser Website werden automatisch
          Informationen durch den Hosting-Anbieter erfasst.
          Dies umfasst beispielsweise IP-Adresse,
          Browsertyp, Betriebssystem sowie Uhrzeit des Zugriffs.
        </p>

      </div>

      <!-- Kontaktformular -->
      <div class="legal-card">

        <h2>4. Kontaktformular</h2>

        <p>
          Wenn Sie uns über das Kontaktformular Anfragen senden,
          werden Ihre Angaben inklusive der von Ihnen angegebenen
          Kontaktdaten gespeichert,
          um die Anfrage zu bearbeiten.
        </p>

        <p>
          Diese Daten geben wir nicht ohne Ihre Einwilligung weiter.
        </p>

      </div>

      <!-- Cookies -->
      <div class="legal-card">

        <h2>5. Cookies</h2>

        <p>
          Diese Website kann technisch notwendige Cookies verwenden,
          um grundlegende Funktionen bereitzustellen.
          Cookies richten auf Ihrem Gerät keinen Schaden an.
        </p>

      </div>

      <!-- Rechte -->
      <div class="legal-card">

        <h2>6. Ihre Rechte</h2>

        <p>
          Sie haben jederzeit das Recht auf Auskunft,
          Berichtigung, Löschung oder Einschränkung
          der Verarbeitung Ihrer gespeicherten Daten.
        </p>

        <p>
          Außerdem steht Ihnen ein Beschwerderecht
          bei der zuständigen Aufsichtsbehörde zu.
        </p>

      </div>

      <!-- SSL -->
      <div class="legal-card">

        <h2>7. SSL- bzw. TLS-Verschlüsselung</h2>

        <p>
          Diese Seite nutzt aus Sicherheitsgründen
          eine SSL- bzw. TLS-Verschlüsselung,
          um vertrauliche Inhalte zu schützen.
        </p>

      </div>

      <!-- Stand -->
      <div class="legal-card">

        <h2>8. Stand</h2>

        <p>
          Stand der Datenschutzerklärung: Mai 2026
        </p>

      </div>

    </div>

  </section>

  <SidebarComponent/>
  <FooterImpressum/>

</template>

<style scoped>
</style>